import { Hub } from 'aws-amplify/utils';

export default () => {
  Hub.dispatch('request_authentication', {});
}
